<div class="modal-header">
  <button type="button" class="close" aria-label="{{'Close'|translate}}" [mat-dialog-close]="true" (click)="onDismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body text-center f-s-18" >
  <i class="fa fa-shopping-cart fa-2x app-primary-text"></i>
  <div class="text-cart my-3 app-primary-text" translate>{{data.title}}</div>
</div>
<div class="modal-footer justify-content-center">
  @if (data.continueText) {
    <button cdkFocusInitial class="btn app-btn-continue-shopping mx-2 rounded-pill" [mat-dialog-close]="true" (click)="onDismiss()" translate>{{data.continueText}}</button>
  }
  @if (data.redirectText && data.redirectLink) {
    <button routerLink="{{data.redirectLink}}" class="btn app-btn-view-cart rounded-pill" [mat-dialog-close]="true" translate>{{data.redirectText}}</button>
  }
  @if (data.redirectText && !data.redirectLink) {
    <button  class="btn app-btn-view-cart rounded-pill" [mat-dialog-close]="true" (click)="onConfirm()" translate>{{data.redirectText}}</button>
  }
  @if (data.redirectWithRefresh && !data.redirectLink) {
    <a href="{{data.redirectWithRefresh}}" [mat-dialog-close]="true" (click)="onConfirm()" class="btn app-btn-view-cart"  translate>{{data.redirectWithRefreshText}}</a>
  }
</div>
